export default function initStickyNavbar(selector = '#site-header') {
  const header = document.querySelector(selector);
  if (!header) return;

  // Hysterese (getrennte Ein-/Ausschalt-Schwellen) plus ein kurzes Debounce:
  // Am oberen Rand bounced macOS-Trackpad-Scrolling elastisch (Rubber-Banding),
  // wodurch scrollY mehrfach über den Nulldurchgang hinaus schwingt. Ein reiner
  // Schwellenwert-Puffer reicht dafür nicht immer aus. Das Debounce sorgt dafür,
  // dass die Klasse erst kippt, wenn die Scroll-Bewegung kurz zur Ruhe kommt,
  // statt bei jeder Bounce-Welle erneut zu reagieren.
  const enterThreshold = 32;
  const leaveThreshold = 6;
  const settleDelay = 120;
  let debounceId = null;

  const update = () => {
    const scrolled = header.classList.contains('is-scrolled')
      ? window.scrollY > leaveThreshold
      : window.scrollY > enterThreshold;
    header.classList.toggle('is-scrolled', scrolled);
  };

  const onScroll = () => {
    if (debounceId) window.clearTimeout(debounceId);
    debounceId = window.setTimeout(() => {
      debounceId = null;
      window.requestAnimationFrame(update);
    }, settleDelay);
  };

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
}
